import React, { useRef } from "react";
import { Box, Typography } from "@bca/ui-library";
import { OverlayContainer, useOverlay } from "@react-aria/overlays";
import { FocusScope } from "@react-aria/focus";
import styled from "styled-components";

import FilterCategories from "./FilterCategories";
import ApplyFiltersFooter from "./ApplyFiltersFooter";
import CloseButton from "./CloseButton";
import { ViewportSizeType } from "../hooks/useViewport.hook";
import { StoreType } from "../StoreType";
import { useSelector } from "react-redux";
import { GET_STATE } from "../redux/slices/appSlice";

const FiltersContainer = styled(Box)`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
`;

const FiltersBarTablet: React.FunctionComponent<{
  onClose: () => void;
  isOpen: boolean;
  setSelectedVehicles;
  appliedCheckboxes;
  setAppliedCheckboxes;
  filtersCount;
  onClearAllFilters;
  resultCount;
  searchResultsLoading: boolean;
  viewportWidth: ViewportSizeType;
}> = ({
  onClose,
  isOpen,
  setSelectedVehicles,
  appliedCheckboxes,
  setAppliedCheckboxes,
  filtersCount,
  onClearAllFilters,
  resultCount,
  searchResultsLoading,
}) => {
  const {
    app: { totalTracked },
  }: StoreType = useSelector(GET_STATE);

  const ref = useRef(null);
  const { overlayProps, underlayProps } = useOverlay(
    {
      onClose,
      isOpen,
      isDismissable: true,
    },
    ref
  );

  return (
    <OverlayContainer>
      <FiltersContainer {...overlayProps}>
        <Box
          width="100vw"
          height="100vh"
          backgroundColor="rgba(0,0,0,0.5)"
          {...underlayProps}
        />
        <FocusScope contain restoreFocus>
          <Box
            ref={ref}
            as="aside"
            maxWidth="332px"
            height="100%"
            px={5}
            py={6}
            css={`
              position: fixed;
              z-index: 11;
              top: 0;
              left: 0;
              overflow-y: auto;
            `}
            backgroundColor="primary-white"
          >
            <Box display="flex" flexDirection="row" pb={7}>
              <Typography variant="h4" my={0}>
                Filters
              </Typography>
              <CloseButton onClick={onClose} />
            </Box>
            <FilterCategories
              setSelectedVehicles={setSelectedVehicles}
              appliedCheckboxes={appliedCheckboxes}
              setAppliedCheckboxes={setAppliedCheckboxes}
              searchResultsLoading={searchResultsLoading}
            />
            <ApplyFiltersFooter
              filtersCount={filtersCount}
              onClearAllFilters={onClearAllFilters}
              resultCount={resultCount}
              onClose={onClose}
              totalTracked={totalTracked}
            />
          </Box>
        </FocusScope>
      </FiltersContainer>
    </OverlayContainer>
  );
};

export default FiltersBarTablet;
